// ── 상품 관리 ⚙️ 설정 모달 ────────────────────────────────────────────────
// 2026-09-20: 가끔 쓰는 것만 여기 둔다 — 유효기간 · 환산장수 · 기본상품.
//   카테고리·상품 이름과 회사 연결은 본문(밖)에서 하고, 일일콜 표시 방식은 "회사에 붙이기" 칸에 있다.
// 노출: 상품 관리(PRODUCT_MANAGEMENT) 또는 동적 관리(TICKET_TYPE_MANAGEMENT) 보유자 — 호출부가 판단(fail-closed).
//   환산장수·기본상품은 전역 데이터라 서버가 운영사 소속인지 한 번 더 본다(requirePlatformViewer).
import React, { useEffect } from 'react';
import Modal from '../../../components/Modal';
import { useTicketManagement } from '../tickettypemanagement/useTicketManagement';
import { ProductsAndFeedbackSection } from '../tickettypemanagement/ProductsAndFeedbackSection';

export function ProductSettingsModal({ open, onClose }) {
  const state = useTicketManagement();

  // 열 때마다 새로 읽는다 (동적 관리나 다른 관리자가 바꾼 값 반영)
  useEffect(() => {
    if (!open) return;
    state.fetchCategories();
    state.fetchTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="상품 설정"
      icon="📦"
      width="min(1100px, calc(100vw - 48px))"
    >
      {/* 유효기간 · 환산장수 · 기본상품만 */}
      <ProductsAndFeedbackSection {...state} ticketSaving={state.saving} />
    </Modal>
  );
}
